import React from "react";
import { useTheme } from "@mui/material/styles";

const target = import.meta.env.VITE_TARGET;

interface LoadingFallbackProps {
    message?: string;
}

const LoadingFallback: React.FC<LoadingFallbackProps> = ({message = "Loading..."}) => {
    const theme = useTheme();
    const mode = theme.palette.mode;

    var logoType = "";
    if (target === "office") {
        logoType = "_office";
    } else if (target === "xcom") {
        logoType = "_xcom";
    }

    const logo = `/evcon_logo${logoType}_${mode}.svg`;
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "24px",
                height: "100vh",
            }}
        >
            <img src={logo} alt="evcon" style={{height: 50}}/>
            <div
                style={{
                    width: 40,
                    height: 40,
                    border: `3px solid ${theme.palette.action.disabledBackground}`,
                    borderTopColor: theme.palette.primary.main,
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                }}
            />
            <span style={{fontSize: 14, color: theme.palette.text.secondary}}>{message}</span>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
};

export default LoadingFallback;